<main>
    <section class="hero-portafolio">
        <div class="imagen-hero-portafolio"></div>
        <div class="texto-hero-portafolio">
            <div class="circulo-azul-hero-portafolio"></div>
            <h1>Conoce nuestro <span>trabajo</span></h1>
            <p>En <strong>Corporación Rehobot</strong> contamos con una trayectoria consolidada en el desarrollo e implementación de soluciones técnicas para proyectos de infraestructura a nivel nacional. Nuestra participación abarca desde intervenciones locales hasta obras de gran escala, siempre con el compromiso de aportar <strong>calidad, seguridad y eficiencia operativa.</strong> Dentro de nuestro portafolio, hemos sido parte de proyectos considerados estratégicos por su impacto en el desarrollo poblacional e industrial, la gestión hídrica y el fortalecimiento del sistema de transporte e infraestructura pública del país. Estas obras reflejan nuestra capacidad para adaptarnos a entornos técnicos exigentes y cumplir con los más altos estándares del sector.</p>
            <p>A continuación, presentamos una muestra representativa de proyectos de alto impacto en los que hemos intervenido, con espacio para detallar los servicios específicos brindados por nuestra empresa.</p>
        </div>
    </section>

    <section class="seccion-listado-obras">
        <div class="contenedor">
            <h2>Listado de <span>Obras.</span></h2>

            <div class="grid-obras">
                
                <div class="tarjeta-obra" *ngFor="let obra of obras" [attr.data-categoria]="obra.categoria">
                    
                    <div class="imagen-obra" [style.background-image]="'url(' + obra.imagen + ')'"></div>
                    
                    <div class="contenido-obra">
                        <h3>{{ obra.titulo }}</h3>
                        
                        <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                    </div>
                </div>

            </div>
        </div>
    </section>
</main>